import { render, staticRenderFns } from "./MembersNearbyPage.vue?vue&type=template&id=5ca5d279"
import script from "./MembersNearbyPage.vue?vue&type=script&lang=js"
export * from "./MembersNearbyPage.vue?vue&type=script&lang=js"
import style0 from "./MembersNearbyPage.vue?vue&type=style&index=0&id=5ca5d279&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports